export const analytics = {
  gtag: {
    event: (action: string, params?: Record<string, string>) => {
      if (process.env.ENV === 'local') {
        console.log('gtag [local]:', action, params);
        return;
      }

      // @ts-expect-error gtag is added in html.head:
      const { gtag } = window;

      if (gtag) {
        console.log('gtag:', action, params);
        gtag('event', action, params);
      } else {
        console.log('%cgtag is undefined', 'color: red');
      }
    },
  },
};
